const getLocaleDistanceUnit = (locale) => {
  if (['en', 'en-GB'].indexOf(locale) !== -1) {
    return { unit: 'mi', conversion: { from_km: 0.62137119 } };
  }

  return { unit: 'km', conversion: { from_km: 1 } };
};

export default getLocaleDistanceUnit;
